import { FilterForm } from "./web/filter-form";
import { onDocumentReady } from "./common/on-document-ready";
import { Tooltip } from "./common/tooltip";
import { Select } from "./common/select2/select";
import { ChainedSelect } from "./common/chained-select";
import { AutoReload } from "./common/auto-reload";
import { SessionFiltersFinder } from "./web/filters/session-filters-finder";
import { waitForJQuery } from "./common/jquery-waiter";
onDocumentReady(function () {
    waitForJQuery(() => {
        callCatchingException(initializeSelect2);
        callCatchingException(initializeAutoReload);
        callCatchingException(initializeChainedSelects);
        callCatchingException(initializeSessionSearchForm);
        callCatchingException(initializeTooltip);
    });
});
callCatchingException(SessionFiltersFinder.init);
function initializeSelect2() {
    Select.initialize();
}
function initializeAutoReload() {
    AutoReload.initialize();
}
function initializeChainedSelects() {
    ChainedSelect.initialize();
}
function initializeSessionSearchForm() {
    new FilterForm();
}
function initializeTooltip() {
    new Tooltip();
}
function callCatchingException(callback) {
    try {
        callback();
    }
    catch (error) {
        console.error(error);
    }
}
